module.exports = __webpack_public_path__ + "static/media/ic_notify_face_update.ad6a63f5.svg";